import { createSelector } from 'reselect';

const selectTrainings = state => state.training.trainings;
export const selectTrainingTrainings = createSelector(
  [selectTrainings],
  (trainings) => trainings
);